import { Icon, IIconName } from '@features/siteStatusV2/components/icon';
import { OrderCategory } from '@features/siteStatusV2/constants';
import theme from '@theme';
import React from 'react';
import styled from 'styled-components';

interface CategoryBadgeProps {
  category: OrderCategory;
}

const CategoryBadge: React.FC<CategoryBadgeProps> = ({ category }) => {
  let label: string;
  let icon: IIconName;
  switch (category) {
    case OrderCategory.FTTH:
      label = 'FTTH';
      icon = { iconName: 'home' };
      break;
    case OrderCategory.FIBER_PREP:
      label = 'Pré-Racco';
      icon = { iconName: 'plug-fill' };
      break;
    case OrderCategory.ADDUCTION:
      label = 'Addu';
      icon = { iconName: 'road' };
      break;
    default:
      label = 'FTTH';
      icon = { iconName: 'home' };
  }

  return (
    <OfferType className="d-flex align-items-center">
      <CustomIcon iconName={icon.iconName} />
      <OrderTagText>{label}</OrderTagText>
    </OfferType>
  );
};

const CustomIcon = styled(Icon)`
  width: 0.625rem;
  color: ${theme.palette.orange[500]};
  fill: ${theme.palette.orange[500]};
`;

const SharedBeforeStyles = `
  content: "";
  display: inline-block;
  position: absolute;
  left: -0.565rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0.25rem;
  height: 0.25rem;
  background: ${theme.palette.grey[300]};
  border-radius: 50%;
`;

const OrderTagText = styled.span`
  margin-left: 0.25rem;
`;

const OfferType = styled.div`
  position: relative;
  font-size: 0.625rem;
  font-weight: 500;
  line-height: 0.75rem;
  color: ${theme.palette.orange[500]};
  padding: 0.1875rem 0.25rem 0.1875rem 0.5rem;
  border-radius: 0.25rem;
  background-color: ${theme.palette.orange[100]};
  margin-left: 0.9375rem;

  &::before {
    ${SharedBeforeStyles};
  }
`;

export default CategoryBadge;
